var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;var locals_for_with = (locals || {});(function (contactUsForm) {pug_html = pug_html + "\u003Cdiv class=\"contact-us-app\"\u003E" + (null == (pug_interp = contactUsForm) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";}.call(this,"contactUsForm" in locals_for_with?locals_for_with.contactUsForm:typeof contactUsForm!=="undefined"?contactUsForm:undefined));;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/pages/b2e/view/partials/contact-form-module.pug
// module id = 1131
// module chunks = 0